<script lang="ts">
  import { onMount } from 'svelte'
  import { get } from 'svelte/store'
  
  import { evmFn } from '@packages/stores'
  import { Assets } from '@packages/ui'
  
  import { configStore } from '@src/stores/config'
  import { type TGetAssetsResult } from '@src/utils/types'
  
  const { getAssets } = get(evmFn)
  const assetsConfig = get(configStore).walletAssets
  
  let assets: TGetAssetsResult = $state([])
  let isLoading = $state(false)
  
  onMount(async () => {
    if (!assetsConfig?.length) return
    
    isLoading = true
    try {
      assets = await getAssets({ assetsConfig, opts: { fetchMetadata: true }})
    } catch {}
    isLoading = false
  })
</script>

<Assets options={{
  title: 'My Assets',
  description: '',
  assets,
}} isLoading={isLoading} />
